import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/motion";
import { EMAIL } from "../data/site";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <section className="pt-32 lg:pt-44 pb-24" data-testid="privacy-page">
        <div className="mx-auto max-w-3xl px-6 lg:px-10">
          <Reveal>
            <h1 className="font-editorial font-black text-navy tracking-tight text-4xl sm:text-5xl">
              Privacy Policy
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-6 font-body text-slate-600 leading-relaxed text-lg">
              <p>
                Second Chance CPR respects your privacy. Any information you
                share with us through our training request form is used only to
                respond to your inquiry and to arrange your CPR, AED, First Aid,
                or BLS training.
              </p>
              <p>
                We do not sell or share your personal information with third
                parties for marketing purposes. Information submitted through
                our contact form is used solely to communicate with you about
                your training request.
              </p>
              <p>
                If you have any questions about how your information is used, or
                would like your information removed from our records, please
                email us at{" "}
                <a href={`mailto:${EMAIL}`} className="text-teal font-semibold">
                  {EMAIL}
                </a>
                .
              </p>
              <p className="text-sm text-slate-400">
                Copyright © 2026 Second Chance CPR
              </p>
            </div>
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
}
